import {useQuery} from '@tanstack/react-query';

import {getGenericYieldWhenHarvestedForSimpleCalculators, getHarvestedMCForSimpleCalculators} from './calculations';
import {SimpleCalculatorCrop} from './types';

type Input = {
  availableLand?: number;
  cropId?: SimpleCalculatorCrop;
};

type Output = {
  harvestedMC?: number;
  genericYield?: number;
  matureProduction?: number;
};

export function calculateProduction({availableLand, cropId}: Input): Output {
  const harvestedMC = cropId ? getHarvestedMCForSimpleCalculators(cropId) : undefined;
  const genericYield = cropId ? getGenericYieldWhenHarvestedForSimpleCalculators(cropId) : undefined;
  const matureProduction =
    genericYield !== undefined && availableLand !== undefined ? genericYield * availableLand : undefined;

  return {
    harvestedMC,
    genericYield,
    matureProduction,
  };
}

export function useProductionCalculator(input: Input) {
  return useQuery({
    queryKey: [input.availableLand, input.cropId],
    queryFn: () => calculateProduction(input),
  });
}
